// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/store';

export const getOrdersByIndex = (state: ReduxStateShared) => state.checkout.ordersByIndex;
export const getOrderIndex = (state: ReduxStateShared) => state.checkout.orderIndex;
